<template>


  <!-- <div v-if="route.path != '/login'"> -->
  <div v-if="route.path == '/login'">
    <router-view></router-view>
  </div>
  <div v-else-if="route.path == '/signup'">
    <router-view></router-view>
  </div>
  <div v-else-if="route.query.email">
    <router-view></router-view>
  </div>
  <div v-else-if="route.path == '/forgot-password'">
    <router-view></router-view>
  </div>
  <div v-else>
    <div class="page-wrapper" :class="toggle === true ? 'toggled' : ''">
      <sidebar />
      <main class="page-content bg-gray-50 dark:bg-slate-800">
        <headers :handlerClick="toggled" />
        <router-view></router-view>
        <footers />
      </main>
    </div>

    <switcher />
  </div>

</template>

<script setup>

import { onMounted } from 'vue';
import { useAuthStore } from './stores/auth';
const authStore = useAuthStore();
const router = useRouter()
const route = useRoute();

onMounted(async () => {
  await authStore.getUser();
  await router.isReady()
  // console.log('route.path', route.path)
})


// console.log(route.query.email);
import { ref } from 'vue'
import sidebar from '@/components/sidebar/sidebar.vue';
import headers from '@/components/header/header.vue';
// import users from '@/components/users/Users.vue';
import footers from '@/components/footer/footer.vue';
import switcher from '@/components/switcher.vue'
import { useRoute, useRouter } from 'vue-router';
const toggle = ref(true)

function toggled() {
  toggle.value = !toggle.value
}

// export default {
//   name: 'App',
//   components: {
//   }
// }
</script>

<style></style>
